import { WizardSessionDTO } from "../DTO/wizardSessionDTO";

export class WizardSession{
    public id!:number;
    public userId!:number;
    public sessionData?:WizardSessionData;
    public added?:Date;
    public edited?:Date;
    public sessionFinalized:boolean = false;

    public static mapFromDTO(param:WizardSessionDTO):WizardSession{ 
        if (!param) throw new Error("parameter is null")
        let obj = new WizardSession();
        try
        {
            obj.id = param.id;
            obj.userId = param.userId;
            if(param.sessionData) obj.sessionData = Object.assign(new WizardSessionData(), JSON.parse(param.sessionData));
            if(param.added) obj.added = new Date(param.added);
            if(param.edited) obj.edited = new Date(param.edited);
            obj.sessionFinalized = param.sessionFinalized;
        }
        catch(e)
        {
            console.log(e);
        }
        return obj;
    }

    public static mapToDTO(param:WizardSession):WizardSessionDTO{ 
        if (!param) throw new Error("parameter is null")
        let dto = new WizardSessionDTO();
        try
        {
            dto.id = param.id;
            dto.userId = param.userId;
            if(param.sessionData) dto.sessionData = JSON.stringify(param.sessionData);
            if(param.added) dto.added = param.added.toISOString();
            if(param.edited) dto.edited = param.edited.toISOString();
            dto.sessionFinalized = param.sessionFinalized;
        }
        catch(e)
        {
            console.log(e);
        }
        return dto;
    }
}

export class WizardSessionData{
    public name? : string;
    public description? : string;
    public integratesWith?:string;
    public usageType?:number;
    public integrationType?:number;
    public billingBucketId?:number;

    public fileDefinitionOption?:number;
    public fileDefinitionOptionPath?:string;
    public fileDefinitionId?:number;
    public fileDefinitionValid?:boolean;

    public filterDefinitionOption?:number;
    public filterDefinitionOptionPath?:string;
    public filterDefinitionId?:number;
    public filterDefinitionValid?:boolean;

    public transformationDefinitionOption?:number;
    public transformationDefinitionOptionPath?:string;
    public transformationDefinitionId?:number;
    public transformationDefinitionValid?:boolean;

    public moovDefinitionOption?:number;
    public moovDefinitionOptionPath?:string;
    public moovDefinitionId?:number;
} 